import React from 'react';
import { Category } from 'types';
import { useCategories } from './useCategories';
import { useLocation } from 'react-router-dom';

function findCategoryName(categories: Category[], id?: string) {
  const category = categories.find((category: Category) => Number(category.id) === Number(id));
  return category ? category.name : '';
}

function useCurrentCategoryName() {
  const initialRender = React.useRef(true);
  const { categories } = useCategories();
  const id = useLocation()
    .pathname.split('/')
    .find((id) => id !== '');
  const [currentCategoryName, setCurrentCategoryName] = React.useState(
    findCategoryName(categories, id)
  );
  React.useEffect(() => {
    if (!initialRender.current) {
      setCurrentCategoryName(findCategoryName(categories, id));
    } else {
      initialRender.current = false;
    }
  }, [id]);
  return {
    currentCategoryName,
  };
}

export default useCurrentCategoryName;
